import clsx from 'clsx';
import { ReactNode } from 'react';

type ControlHitAreaProps = {
  children: ReactNode;
  disabled?: boolean;
  as?: 'label' | 'span';
};

export default function ControlHitArea({
  children,
  disabled = false,
  as = 'label'
}: ControlHitAreaProps) {
  const className = clsx(
    '-m-2 inline-flex shrink-0 p-2',
    disabled ? 'cursor-not-allowed' : 'cursor-pointer'
  );

  if (as === 'span') {
    return <span className={className}>{children}</span>;
  }

  return <label className={className}>{children}</label>;
}
